module.exports = {
    url: 'https://wpsolution.app/'
}